import React from 'react';
import Helmet from 'react-helmet';
import head from '../../utils/head';
import { addDashesToUUID } from 'src/shared/converters';
import { isPrerender } from '../../utils/prerenderDetect';
import { useSelector } from 'src/client/redux';

export const HTMLHead = () => {
  const site = useSelector((state) => state.site);
  const { ataBundleUrl, cdnUrl, config } = useSelector((state) => state.app);

  return (
    <Helmet {...head(config, site, cdnUrl)}>
      <link rel="apple-touch-icon" href={`${cdnUrl}/icons/${site.abbreviation}_512.png`} />
      <link rel="shortcut icon" href={`${cdnUrl}/favicon/${site.abbreviation}.ico`} />
      <meta name="theme-color" content={`${config.pwaPrimaryColor || '#000000'}`} />

      {!isPrerender && <script>{getATAScript(ataBundleUrl, addDashesToUUID(site.networkUUID))}</script>}
    </Helmet>
  );
};

const getATAScript = (ataBundleUrl: string, networkUUID: string) => `
  !function(t,r){window.ata=r,r.init=function(t,a){r._token=t,a&&(r._initParams=a)},r._calls=[];for(var a=["track"],c=0;c<a.length;c+=1){var e=a[c];r[e]=function(t){return function(){r._calls.push([t,Array.prototype.slice.call(arguments,0)])}}(e)}script=t.createElement("script"),script.type="text/javascript",script.async=!0,script.src="${ataBundleUrl}",scriptTag=t.getElementsByTagName("script")[0],scriptTag.parentNode.insertBefore(script,scriptTag)}(document,window.ata||[]);
  ata.init('${networkUUID}');
`;
